module.exports = __webpack_public_path__ + "static/media/icon-score-5-scale-5.733e73b6.png";